// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"fc605f2c","94":"af7eba73","440":"5625a608","522":"548a801e","714":"f988084e"}[chunkId] + ".chunk.css";
};